import React, { useState, useRef } from 'react'
import Table, { IGallery, IEmpty } from './Table'
import { Toast } from 'primereact/toast';
import { Form } from './Form';
import { IPermissionProps } from '../../models/Login';


export interface IModal {
    singleData: IGallery,
    open: boolean
}

export const Gallery = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: IEmpty, open: false });
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>

    )
}

